import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Adds https:// to a web address when missing. Returns null for empty input. */
export function normalizeUrl(value?: string | null): string | null {
  const v = (value ?? "").trim();
  if (!v) return null;
  return /^https?:\/\//i.test(v) ? v : `https://${v.replace(/^\/+/, "")}`;
}

/** True when the value (after adding https://) looks like a real web address. */
export function isValidWebUrl(value?: string | null): boolean {
  const n = normalizeUrl(value);
  if (!n) return true;
  if (/\s/.test(n)) return false;
  try {
    const u = new URL(n);
    return u.hostname.includes(".");
  } catch {
    return false;
  }
}
